export default "__VITE_ASSET__bmpqN3X4__"